import {
  toButtonsContent,
  toCardGridContent,
  toGalleryContent,
  toHeroContent,
  toIframeContent,
  toIconListContent,
  toPeopleContent,
  toStatsContent,
  toTextContent,
} from "./blockContent";

import { LANDING_PAGE_TYPE, SIMPLE_PAGE_TYPE } from "../pageTypeRegistry";

export type BlockTypeDefinition = {
  key: string;
  name: string;
  defaultContent: Record<string, unknown>;
  layouts?: readonly string[];
};

const BLOCK_TYPE_REGISTRY: BlockTypeDefinition[] = [
  {
    key: "block_card_grid",
    name: "Card Grid",
    defaultContent: toCardGridContent(null),
  },
  {
    key: "block_card_modal_grid",
    name: "Card Modal Grid",
    defaultContent: {
      cards: [],
    },
  },
  {
    key: "block_iframe",
    name: "Iframe",
    defaultContent: toIframeContent(null),
  },
  {
    key: "block_address_grid",
    name: "Address Grid",
    defaultContent: {
      addresses: [],
    },
  },
  { key: "block_hero", name: "Hero", defaultContent: toHeroContent(null) },
  { key: "block_text", name: "Text", defaultContent: toTextContent(null) },
  { key: "block_stats", name: "Stats", defaultContent: toStatsContent(null) },
  { key: "block_people", name: "People", defaultContent: toPeopleContent(null) },
  { key: "block_icon_list", name: "Icon List", defaultContent: toIconListContent(null) },
  { key: "block_buttons", name: "Buttons", defaultContent: toButtonsContent(null) },
  { key: "block_gallery", name: "Gallery", defaultContent: toGalleryContent(null) },
  {
    key: "block_banner",
    name: "Banner",
    layouts: [LANDING_PAGE_TYPE],
    defaultContent: { background: "dark", title: "", tagline: "" },
  },
  {
    key: "block_steps",
    name: "Steps",
    layouts: [LANDING_PAGE_TYPE],
    defaultContent: { background: "default", items: [] },
  },
  {
    key: "block_video",
    name: "Video",
    layouts: [LANDING_PAGE_TYPE],
    defaultContent: { background: "default", url: "", title: "" },
  },
  {
    key: "block_accordion",
    name: "Accordion",
    layouts: [LANDING_PAGE_TYPE, SIMPLE_PAGE_TYPE],
    defaultContent: { background: "default", items: [] },
  },
  {
    key: "block_call_to_action",
    name: "Call to Action",
    layouts: [LANDING_PAGE_TYPE],
    defaultContent: {
      background: "brand",
      buttons: [{ label: "", href: "", variant: "primary" }],
    },
  },
];

export function getBlockTypes(): BlockTypeDefinition[] {
  return BLOCK_TYPE_REGISTRY;
}

export function getBlockTypesForPage(
  pageType: string,
  currentBlockType?: string,
): BlockTypeDefinition[] {
  return BLOCK_TYPE_REGISTRY.filter(
    blockType =>
      blockType.layouts === undefined ||
      blockType.layouts.includes(pageType) ||
      blockType.key === currentBlockType,
  );
}

export function getBlockType(key: string): BlockTypeDefinition | undefined {
  return BLOCK_TYPE_REGISTRY.find(bt => bt.key === key);
}
